function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Alert, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CompetentProfessionalListRow from './CompetentProfessionalListRow';
const CompetentProfessionalList = _ref => {
  let {
    companyId,
    setData,
    data,
    selectedProjectId,
    emptyList,
    removeEmptyRow,
    tableHeadings,
    showFileColumns,
    searchQuery,
    forNewProjectCreation = false,
    addCompetentProfessionalToNewProject,
    updateNewProjectCompetentProfessionals,
    removeNewProjectCompetentProfessional
  } = _ref;
  const {
    t
  } = useTranslation();
  const [duplicates, setDuplicates] = useState([]);
  useEffect(() => {
    const emails = data.map(a => a.email);
    const count = emails => emails.reduce((result, value) => _objectSpread(_objectSpread({}, result), {}, {
      [value]: (result[value] || 0) + 1
    }), {}); // don't forget to initialize the accumulator
    const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);
    setDuplicates(duplicates(count(emails)).filter(e => e !== '').filter(e => e !== null).filter(e => e !== undefined).filter(e => e !== 'null'));
  }, [data]);
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });

  // console.log('From CompetentProfessionalList: ', data)

  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(CompetentProfessionalListRow, {
      companyId: companyId,
      rowData: currentData,
      key: currentData.id,
      data: data,
      setData: setData,
      tableHeadings: tableHeadings,
      showFileColumns: showFileColumns,
      selectedProjectId: selectedProjectId,
      forNewProjectCreation: forNewProjectCreation,
      removeNewProjectCompetentProfessional: removeNewProjectCompetentProfessional,
      addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
      updateNewProjectCompetentProfessionals: updateNewProjectCompetentProfessionals
    });
  });
  const emptyRows = emptyList.map(emptyRow => {
    return /*#__PURE__*/React.createElement(CompetentProfessionalListRow, {
      companyId: companyId,
      key: 'createRowList' + emptyRow.emptyRowId,
      emptyRowId: emptyRow.emptyRowId,
      data: data,
      setData: setData,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyRow,
      tableHeadings: tableHeadings,
      showFileColumns: showFileColumns,
      selectedProjectId: selectedProjectId,
      forNewProjectCreation: forNewProjectCreation,
      removeNewProjectCompetentProfessional: removeNewProjectCompetentProfessional,
      addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
      updateNewProjectCompetentProfessionals: updateNewProjectCompetentProfessionals
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, duplicates.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger"
  }, "Be careful you have created competent professionals with the same e-mail address ", duplicates.join(', ')), /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, !searchQuery.length && emptyRows)));
};
export default CompetentProfessionalList;